import {InjectionToken} from '@angular/core'
import {UVEApiEmbeddedService} from '@service/uve/api-embedded.service'
import {UVEApiService} from '@service/uve/api.service'
import type {EmbeddedClientService} from '@service/embeddingService/embedded-client.service'

/**
 * Factory que resuelve la implementación adecuada de `UVEApiService`.
 *
 * @description
 * En modo embebido devuelve `UVEApiEmbeddedService`, que redirige las
 * llamadas al host. En modo standalone devuelve `UVEApiService`, el
 * cliente HTTP hacia la API de UVE que consumen los servicios de dominio.
 *
 * @param embeddedClientService Cliente que detecta si la app corre embebida.
 * @returns Instancia activa de `UVEApiService`.
 */
export function providerUVEApiServiceFactory(embeddedClientService: EmbeddedClientService) {
  return embeddedClientService.isEmbeddedFunction() ? new UVEApiEmbeddedService() : new UVEApiService()
}

/**
 * `InjectionToken` que referencia la instancia activa de `UVEApiService`.
 *
 * @description
 * Registrado en `SERVICE_PROVIDERS` junto con
 * {@link providerUVEApiServiceFactory}. Los servicios de dominio
 * inyectan directamente `UVEApiService` (no el token).
 */
export const UVEApiServiceToken = new InjectionToken<UVEApiService>('UVEApiService')
